import React from 'react';
import Image from '../assets/images/igdtuw-logo.png';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';


const SEO = ({ 
  title = "IGDTUW - Delhi", 
  description = "Indira Gandhi Delhi Technical University for Women (Established by Govt. of Delhi vide Act 9 of 2012)",
  keyword = "IGDTUW, IGDTUW Delhi, Indira Gandhi Delhi Technical University for Women, University in Delhi, University for Women, Women's technical education", 
  image = Image, 
  schema = null,
  noindex = false }) => {
  const location = useLocation();
  const currentUrl = decodeURI(`${window.location.origin}${location.pathname}`);
  return (
    <HelmetProvider>
    <Helmet>
      <title>{title}</title>
      { noindex && <meta name="robots" content="noindex" /> }
      <meta name="description" content={description} />
      <meta name="keyword" content={keyword} />
      <link rel="canonical" href={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
    </HelmetProvider>
  );
};

export default SEO;
